import { useRef } from "react"
import { isAndroid, isIOS } from "@mylaunch/pwa/lib/platform"

export function usePreOpenSystemBrowser() {
  const ref = useRef<Window | null>(null)
  const enabled = isIOS() || isAndroid()

  const preOpen = (url: string = "about:blank") => {
    if (ref.current || !enabled) return
    ref.current = window.open(url, "_blank")
  }
  const goTo = (url: string) => {
    if (ref.current) ref.current.location.href = url
    else ref.current = window.open(url, "_blank")
  }
  const close = () => {
    if (!ref.current) return
    ref.current.close()
    ref.current = null
  }
  const dropRef = () => { ref.current = null }
  const isOpen = () => Boolean(ref.current)

  return { preOpen, goTo, close, dropRef, isOpen }
}
